import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
import React, { useState} from 'react';
import { createPortal } from "react-dom";
export const DepensesBullet = () =>{
    

    
    return(
    
        <div id="articleContent" className="bulletJournal ToDoList DepensesBullet">
        <a class="button only" target="_blank"   onClick={(event) => {window.print()} }>Imprimer cette page</a>

        
       <div>
           <div>
           <div class="spaceForTitle">Dépenses mensuelles<span></span></div>
           <ul>
           <li><span>Date</span><span>Libellé</span><span>Coût</span></li>
           <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
           </ul>
           </div>

           <div>
           <div class="spaceForTitle">Dépenses mensuelles<span></span></div>
           <ul>
           <li><span>Date</span><span>Libellé</span><span>Coût</span></li>
           <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
               <li><span></span><span></span><span></span></li>
           </ul>
           </div>
        </div>
      </div>
    )
}
